
import { ActionList, GameStatusAction } from "@/models/MapPois/Quest/Actions";
import { GAME_STATUS } from "@/models/MapPois/Quest/QuestsEnum";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
class ActionGameStatusEdit extends Vue {
  @Prop({ default: false }) readonly contentData!: ActionList;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: false }) readonly showTextBox!: boolean;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: "" }) readonly placeholder!: string;

  gameStatusAction: GameStatusAction = {
    parentID: "",
    value: GAME_STATUS.NONE,
    status: "active",
  };

  get getGameStatus(): string[] {
    return ["win", "failed", "expired"];
  }

  created(): void {
    if (this.contentData?.gameStatusAction !== undefined) {
      this.gameStatusAction = this.contentData.gameStatusAction;
    }
  }
  cancel(): void {
    this.$emit("cancel");
  }
  update(): void {
    this.$emit("update", this.gameStatusAction);
  }
}

export default ActionGameStatusEdit;
